// src/components/ErrorMessage.tsx
import React from "react";
import { XCircle } from "lucide-react";

interface ErrorMessageProps {
  message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  return (
    <div className="flex items-center gap-2 p-3 rounded-md bg-red-50 text-red-700 border border-red-200">
      <XCircle size={20} />
      <span>{message}</span>
    </div>
  );
};

export default ErrorMessage;
